import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Label } from '../components';
import cn from 'classnames';
import styles from './LandscapeBaseAddTemplate.module.css';

interface LandscapeBaseAddTemplateProps {
  children: React.ReactNode;
}

const LandscapeBaseAddTemplate: React.FC<LandscapeBaseAddTemplateProps> = ({
  children,
}) => {
  const navigate = useNavigate();
  // const location = useLocation();

  // const getPrimaryTabRoute = (path: string) => {
  //   const segments = path.split('/');
  //   return segments.slice(0, 5).join('/');
  // };

  // const primaryTabRoute = getPrimaryTabRoute(location.pathname);

  return (
    <div>
      <div className={cn(styles.heading)}>
        <Label content={'New Landscape'} size="lg" />
        <Button
          className={styles.buttonLink}
          onClick={() => navigate('/landscapes')}
          variant="link"
        >
          Go back to overview
        </Button>
      </div>
      {/* <TabBar
        onSelect={(id: string | null) => {
          if (id) {
            navigate(id);
          }
        }}
        defaultSelected={primaryTabRoute}
      >
        <TabItem
          title="Basic information"
          id={`/landscapes/add/basic-information`}
        /> */}
      {/* <TabItem title="Landscape about" id={`/landscapes/add/about`} /> */}
      {/* <TabItem title="Indicators" id={`/landscapes/add/indicators`} />
        <TabItem title="Projects" id={`/landscapes/add/projects`} />
        <TabItem
          title="Landscape updates"
          id={`/landscapes/add/landscape-updates`}
        />
        <TabItem title="Commodities" id={`/landscapes/add/commodities`} />
        <TabItem title="Documents" id={`/landscapes/add/documents`} /> */}
      {/* </TabBar> */}
      <main>{children}</main>
    </div>
  );
};

export default LandscapeBaseAddTemplate;
